import { render } from "./ScorePage.vue?vue&type=template&id=01e245f0&ts=true"
import script from "./ScorePage.vue?vue&type=script&lang=ts"
export * from "./ScorePage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__